import React from 'react'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import PropTypes from 'prop-types'
import { zoomSliderProps } from '../types'
class ZoomSlider extends React.Component {
  static propTypes = zoomSliderProps
  captureZoom = value => {
    this.props.updateZoomLevel(value)
    this.props.setZoomLevelState(value)
  }
  render() {
    const railStyles = {
      backgroundColor: ' #fff',
      borderRadius: '0',
      opacity: '0.5',
      height: ' 100%',
      width: '2px',
    }
    return (
      <div className="viewer__slider">
        <div className="viewer__slider__body">
          <Slider
            vertical
            step={0.005}
            onChange={this.captureZoom}
            handleStyle={{
              borderRadius: '1px',
              height: '2px',
              border: 0,
              width: '13px',
            }}
            trackStyle={railStyles}
            railStyle={railStyles}
            defaultValue={this.props.minZoom}
            min={this.props.minZoom}
            max={this.props.maxZoom}
            value={this.props.currentZoom}
          />
        </div>
      </div>
    )
  }
}

export default ZoomSlider
